/**
 * アプリ共通定数
 */
import store from "lib/store";


/**
 * フィールド有無をチェック
 * @param {object | undefined} target
 * @param {string} key search key 
 * @returns target.field.includes
 */
function hasField(target, key) {
  if (target === undefined) {
    return false;
  }

  if (!Array.isArray(target.field)) {
    return false;
  }

  return (target.field.indexOf(key) >= 0);
}


/**
 * オプション設定を生成
 * @param {object} target
 * @param {function} callback(key, value) 
 * @returns target.field.includes
 */
function mapOptions(target, callback) {
  const array = [];

  if (target instanceof Map) {
    for (const item of target) {
      let isItemEnable;

      // オプション指定あり
      if (item[1]?.opt !== undefined) {
        // 施設情報にオプション設定あり
        if (store.getState().schoolInfo.opt[item[1].opt] === true) {
          // アイテム有効
          isItemEnable = true;
        
        // オプション設定なし
        } else {
          // アイテム無効
          isItemEnable = false;
        }
      
      // オプション指定なし
      } else {
        // アイテム有効
        isItemEnable = true;
      }

      // オプション有効の場合のみmapを実行
      if (isItemEnable === true) {
        array.push(callback(item[0], item[1]));
      }
    }
  }
  return array;
}


/* 登降園状態 */
const AttrenrakuState = {
  default: "",
  options: new Map([
    ["", {text: "--"}],
    ["17", {text: "欠席(病欠)"}],
    ["16", {text: "欠席(都合)"}],
    ["33", {text: "早出", field: ["time", "sougei"]}],
    ["34", {text: "遅刻", field: ["time", "sougei"]}],
    ["49", {text: "早退", field: ["time", "sougei"]}],
    ["50", {text: "延長", field: ["time", "sougei"]}],
  ]),
};


/* 出欠 */
const AttState = {
  default: "0",
  options: new Map([
    // bit0-bit2: 010=遅い 001=早い 000=通常
    // bit4: 降園/欠席, bit5: 登園履歴有
    // bit4-5: 00=登園前, 01=欠席, 10=登園, 11=降園
    ["0", {text: "登園前", variant: "atts-before"}],
    // Ver3.4.0で追加 登降園連絡連動の早出・遅刻 ※実際には登園していないので0x0*に割り当て
    ["1", {text: "登園早", variant: "atts-touen-early"}],
    ["2", {text: "登園遅", variant: "atts-touen-behind"}],

    ["16", {text: "欠席都", variant: "atts-kesseki"}],
    ["17", {text: "欠席病", variant: "atts-kesseki-sick"}],
    ["32", {text: "登園", field: ["te"], variant: "atts-touen"}],
    ["48", {text: "降園", field: ["te", "tl"], variant: "atts-kouen"}],

    // Ver3.4.0で登園早・登園遅・降園早・降園延を廃止。データ上整合を取る必要があるため残っている
    ["33", {text: "登園", field: ["te"], variant: "atts-touen"}],       // 登園早
    ["34", {text: "登園", field: ["te"], variant: "atts-touen"}],       // 登園遅
    ["49", {text: "降園", field: ["te", "tl"], variant: "atts-kouen"}], // 降園早
    ["50", {text: "降園", field: ["te", "tl"], variant: "atts-kouen"}], // 降園延
  ]),
};


/* 食事 */
const MealType = {
  options: new Map([
    ["1", {text: "給食", variant: "lunch"}],
    ["2", {text: "おやつ(午前)", variant: "amsnack"}],
    ["3", {text: "おやつ(午後)", variant: "pmsnack"}],
  ])
};


/* 続柄 */
const FamilyRelation = {
  options: new Map([
    ["", {text: "--"}],
    ["父", {text: "父"}],
    ["母", {text: "母"}],
    ["祖父", {text: "祖父"}],
    ["祖母", {text: "祖母"}],
    ["兄", {text: "兄"}],
    ["姉", {text: "姉"}],
    ["その他", {text: "その他"}],
  ])
};


/* エラーメッセージ */
const Messages = {
  NetworkError: "通信エラーが発生しました。時間を空けて再度試行してください。",
  ServerError: "通信エラーが発生しました。時間を空けて再度試行してください。",
  InvalidActionError: "指定された日付にクラスが設定されていないため、登録できませんでした。",
  RequireError: "入力してください",
  SelectError: "選択してください",
  MaxLengthError: "${max}文字以内で入力してください",
  ProhibitCharError: "使用できない文字が入力されています",  // id charactor check
  NotEqualError: "一致していません",                      // password verify
  DateError: "日付が不正です",
  PastDateError: "本日以降の日付を入力してください",
}

export {
  hasField,
  mapOptions,
  AttrenrakuState,
  AttState,
  MealType,
  Messages,
  FamilyRelation,
};
